const countryFlagMapping: Record<string, string> = {
    'Andorra': 'ad',
    'United Arab Emirates': 'ae',
    'Afghanistan': 'af',
    'Antigua and Barbuda': 'ag',
    'Anguilla': 'ai',
    'Albania': 'al',
    'Armenia': 'am',
    // 'Netherlands Antilles': 'an',
    'Angola': 'ao',
    'Antarctica': 'aq',
    'Argentina': 'ar',
    'American Samoa': 'as',
    'Austria': 'at',
    'Australia': 'au',
    'Aruba': 'aw',
    // ax
    'Azerbaijan': 'az',
    'Bosnia Herzegovina': 'ba',
    'Barbados': 'bb',
    'Bangladesh': 'bd',
    'Belgium': 'be',
    'Burkina Faso': 'bf',
    'Bulgaria': 'bg',
    'Bahrain': 'bh',
    'Burundi': 'bi',
    'Benin': 'bj',
    // bl
    'Bermuda': 'bm',
    'Brunei Darussalam': 'bn',
    'Bolivia': 'bo',
    'Bonaire': 'bq',
    'Brazil': 'br',
    'Bahamas': 'bs',
    'Bhutan': 'bt',
    'Bouvet Island': 'bv',
    'Botswana': 'bw',
    'Belarus': 'by',
    'Belize': 'bz',
    'Canada': 'ca',
    'Cocos Islands': 'cc',
    'DR Congo': 'cd',
    'Central African Republic': 'cf',
    'Congo': 'cg',
    'Switzerland': 'ch',
    'Cote d Ivoire': 'ci',
    'Cook Islands': 'ck',
    'Chile': 'cl',
    'Cameroon': 'cm',
    'China': 'cn',
    'Colombia': 'co',
    'Costa Rica': 'cr',
    'Cuba': 'cu',
    'Cape Verde': 'cv',
    'Curacao': 'cw',
    'Christmas Island': 'cx',
    'Cyprus': 'cy',
    'Czech Republic': 'cz',
    'Germany': 'de',
    'Djibouti': 'dj',
    'Denmark': 'dk',
    'Dominica': 'dm',
    'Dominican Republic': 'do',
    'Algeria': 'dz',
    'Ecuador': 'ec',
    'Estonia': 'ee',
    'Egypt': 'eg',
    'Western Sahara': 'eh',
    'Eritrea': 'er',
    'Spain': 'es',
    // es-ct
    // es-ga
    'Ethiopia': 'et',
    // eu
    'Finland': 'fi',
    'Fiji': 'fj',
    'Falkland Islands': 'fk',
    'Micronesia': 'fm',
    'Faroe Islands': 'fo',
    'France': 'fr',
    'Gabon': 'ga',
    'Great Britain': 'gb',
    'England': 'gb-eng',
    'Northern Ireland': 'gb-nir',
    'Scotland': 'gb-sct',
    'Wales': 'gb-wls',
    'Grenada': 'gd',
    'Georgia': 'ge',
    'French Guiana': 'gf',
    'Bailiwick of Guernsey': 'gg',
    'Guernsey': 'gg',
    'Ghana': 'gh',
    'Gibraltar': 'gi',
    'Greenland': 'gl',
    'Gambia': 'gm',
    'Guinea': 'gn',
    'Guadeloupe': 'gp',
    'Equatorial Guinea': 'gq',
    'Greece': 'gr',
    'South Georgia and the South Sandwich Islands': 'gs',
    'Guatemala': 'gt',
    'Guam': 'gu',
    'Guinea Bissau': 'gw',
    'Guyana': 'gy',
    'Hong Kong': 'hk',
    'Heard Island and McDonald Islands': 'hm',
    'Honduras': 'hn',
    'Croatia': 'hr',
    'Haiti': 'ht',
    'Hungary': 'hu',
    'Indonesia': 'id',
    'Republic of Ireland': 'ie',
    'Israel': 'il',
    'Isle of Man': 'im',
    'India': 'in',
    'British Indian Ocean Territory': 'io',
    'Iraq': 'iq',
    'Iran': 'ir',
    'Iceland': 'is',
    'Italy': 'it',
    'Bailiwick of Jersey': 'je',
    'Jersey': 'je',
    'Jamaica': 'jm',
    'Jordan': 'jo',
    'Japan': 'jp',
    'Kenya': 'ke',
    'Kyrgyzstan': 'kg',
    'Cambodia': 'kh',
    'Kiribati': 'ki',
    'Comoros': 'km',
    'St. Kitts & Nevis': 'kn',
    'Korea DPR': 'kp',
    'Korea Republic': 'kr',
    'Kuwait': 'kw',
    'Cayman Islands': 'ky',
    'Kazakhstan': 'kz',
    'Laos': 'la',
    'Lebanon': 'lb',
    'St. Lucia': 'lc',
    'Saint Lucia': 'lc',
    'Liechtenstein': 'li',
    'Sri Lanka': 'lk',
    // 'Lotey': 'lo',
    'Liberia': 'lr',
    'Lesotho': 'ls',
    'Lithuania': 'lt',
    'Luxembourg': 'lu',
    'Latvia': 'lv',
    'Libya': 'ly',
    'Morocco': 'ma',
    'Monaco': 'mc',
    'Moldova': 'md',
    'Montenegro': 'me',
    'Saint Martin': 'mf',
    'Madagascar': 'mg',
    'Marshall Islands': 'mh',
    'Republic of North Macedonia': 'mk',
    'Mali': 'ml',
    'Myanmar': 'mm',
    'Mongolia': 'mn',
    'Macau': 'mo',
    'Northern Mariana Islands': 'mp',
    'Martinique': 'mq',
    'Mauritania': 'mr',
    'Montserrat': 'ms',
    'Malta': 'mt',
    'Mauritius': 'mu',
    'Maldives': 'mv',
    'Malawi': 'mw',
    'Mexico': 'mx',
    'Malaysia': 'my',
    'Mozambique': 'mz',
    'Namibia': 'na',
    'New Caledonia': 'nc',
    'Niger': 'ne',
    'Norfolk Island': 'nf',
    'Nigeria': 'ng',
    'Nicaragua': 'ni',
    'Netherlands': 'nl',
    'Norway': 'no',
    'Nepal': 'np',
    'Nauru': 'nr',
    'Niue': 'nu',
    'New Zealand': 'nz',
    'Oman': 'om',
    'Panama': 'pa',
    'Peru': 'pe',
    'French Polynesia': 'pf',
    'Papua New Guinea': 'pg',
    'Philippines': 'ph',
    'Pakistan': 'pk',
    'Poland': 'pl',
    'Saint Pierre and Miquelon': 'pm',
    'Pitcairn': 'pn',
    'Puerto Rico': 'pr',
    'Palestine': 'ps',
    'Portugal': 'pt',
    'Palau': 'pw',
    'Paraguay': 'py',
    'Qatar': 'qa',
    'Reunion': 're',
    'Romania': 'ro',
    'Serbia': 'rs',
    'Russia': 'ru',
    'Rwanda': 'rw',
    'Saudi Arabia': 'sa',
    'Solomon Islands': 'sb',
    'Seychelles': 'sc',
    'Sudan': 'sd',
    'Sweden': 'se',
    'Singapore': 'sg',
    'Saint Helena': 'sh',
    'Slovenia': 'si',
    'Svalbard and Jan Mayen': 'sj',
    'Slovakia': 'sk',
    'Sierra Leone': 'sl',
    'San Marino': 'sm',
    'Senegal': 'sn',
    'Somalia': 'so',
    'Suriname': 'sr',
    'South Sudan': 'ss',
    'Sao Tome e Principe': 'st',
    'El Salvador': 'sv',
    // sx
    'Syria': 'sy',
    'Eswatini': 'sz',
    'Turks and Caicos Islands': 'tc',
    'Chad': 'td',
    'French Southern Territories': 'tf',
    'Togo': 'tg',
    'Thailand': 'th',
    'Tajikistan': 'tj',
    'Tokelau': 'tk',
    'Timor Leste': 'tl',
    'Turkmenistan': 'tm',
    'Tunisia': 'tn',
    'Tonga': 'to',
    'Turkey': 'tr',
    'Trinidad & Tobago': 'tt',
    'Tuvalu': 'tv',
    'Chinese Taipei': 'tw',
    'Tanzania': 'tz',
    'Ukraine': 'ua',
    'Uganda': 'ug',
    // un
    // 'United Kingdom': 'uk',
    'United States minor outlying islands': 'um',
    'USA': 'us',
    'Uruguay': 'uy',
    'Uzbekistan': 'uz',
    'Vatican City': 'va',
    'St. Vincent & Grenadines': 'vc',
    'Venezuela': 've',
    'British Virgin Islands': 'vg',
    'US Virgin Islands': 'vi',
    'Vietnam': 'vn',
    'Vanuatu': 'vu',
    'Wallis and Futuna': 'wf',
    'Samoa': 'ws',
    'Kosovo': 'xk',
    'Yemen': 'ye',
    'Mayotte': 'yt',
    'South Africa': 'za',
    'Zambia': 'zm',
    'Zimbabwe': 'zw',
};

export function isShowFlag(homeCountry: string, awayCountry: string) {
    const home = getFlagName(homeCountry);
    const away = getFlagName(awayCountry);

    return home !== undefined
        && away !== undefined;
}

export function getFlagName(country: string): string | undefined {
    return countryFlagMapping[country];
}
